import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const SliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .slick-slider {
    max-height: 100% !important;
  }

  .slick-slider:not(.slick-initialized) {
    display: none;
  }

  @media screen and (max-width: 1100px) {
    width: 100%;
  }
`

export const SliderHeader = styled.div`
  padding: 15px 0px;
  background-color: ${props => props.theme.color.white};
  display: flex;
  a {
    font-size: ${props => props.theme.font.size.sm};
    font-family: ${props => props.theme.font.family.bold};
    color: ${props => props.theme.color.black1};
    text-decoration: none;
    display:flex;
    align-items: center;
    img {
      width: 15px;
      height: 15px;
      margin-right: 8px;
    }
    &:not(:last-child) {
      margin-right: 45px;
    }
  }
  @media screen and (min-width: 1100px) {

  }

`

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const SlideTitle = styled.h2`
  color: ${props => props.theme.color.white};
  font-size: 18px;
  line-height: 1.17;
  margin-bottom: 12px;
  font-weight: normal;
  @media screen and (min-width: 1100px) {
    font-family: ${props => props.theme.font.family.bold};
    font-size: ${props => props.theme.font.size.xl};
    order: 1;
  }
`

export const SlideCat = styled.p`
  font-size: ${props => props.theme.font.size.sm};
  font-family: ${props => props.theme.font.family.medium};
  color: ${props => props.theme.color.white};
  font-weight: 500;
  margin-bottom: 8px;
  @media screen and (min-width: 1100px) {
    order: 2;
    margin-bottom: 18px;
  }
`

export const SlidePrice = styled.h3`
  font-size: ${props => props.theme.font.size.lg};
  font-family: ${props => props.theme.font.family.bold};
  color: ${props => props.theme.color.black};
  margin-bottom: 20px;

  @media screen and (min-width: 1100px) {
    span.from {
      font-size: ${props => props.theme.font.size.sm};
      color: ${props => props.theme.color.black4};
      text-transform: uppercase;
      margin-bottom: 5px;
      display: block;
    }
  }
`

export const SlidePic = styled.img`
  position: absolute;
  width: 160px;
  right: -10px;
  top: 20px;
  @media screen and (min-width: 1100px) {
    right: 72px;
    top: 60px;
    width: auto;
  }
`

export const Slide = styled.div`
  position: relative;
  .slick.dots{
    bottom: 0 !important;
  }
  a {
    border-radius: 10px;
    margin: 15px 30px 30px 0;
    padding: 30px 25px 48px 25px;
    position: relative;
    box-sizing: border-box;
    background-image: url('${props => props.image || ''}');
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    outline: none;
    height: 360px;
    width: 100%;
    // aspect-ratio:266/66;
    @supports not (aspect-ratio: auto) {
      padding: 0 !important;
      padding-top: 45.58% !important;
      height: 0;
      position: relative;
      overflow: hidden;

    }
    
    @media screen and (max-width: 768px){
      aspect-ratio:15/10;

      @supports not (aspect-ratio: auto) {
        padding: 0 !important;
        padding-top: 66.66666666666667% !important;
        height: 0;
        position: relative;
        overflow: hidden;

      }
    }
    display: flex !important;
    flex-direction: column;
    justify-content: flex-end;
    
    @media screen and (max-width: 1100px){
      border-radius: 10px;
      margin: 0px 30px 15px 0;
    }
   
    button {
      margin-top: 20px;
      background-color: white;
      color: ${props => props.theme.color.black1};
      font-family: ${props => props.theme.font.family.bold};
    }
  
    &.category {
      padding: 0px;
      background-color: transparent;
    }
    @media screen and (min-width: 1100px) {
      padding: 30px 48px 48px 48px;
  
      background-position: center;
  
    }
  }
`

export const BrandSlide = styled.a`
  display: flex !important;
  flex-direction: column;
  height: 90px;
  justify-content: center;
  align-items: center;
  width: 160px !important;
  background-color: #F2F4F5;
  border-radius: 20px;
  h2{
    padding-bottom: 5px;
  }
  div{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60%;
  }
  img{
    /* margin-top: 10px; */
    object-fit: contain;
    max-width: 95px;
    max-height: 40px;
  }
  @media screen and (max-width: 1399px) {
    width: 145px !important;
    
    img{
      /* margin-top: 10px; */
      object-fit: contain;
      max-width: 95px;
      max-height: 30px;
    }
  }
  
  @media screen and (min-width: 1100px) and (max-width: 1249px) {
    width: 125px !important;

    img{
   
      object-fit: contain;
      max-width: 80px;
      max-height: 40px;
    }
  }
  
  @media screen and (min-width: 768px) and (max-width: 900px) {
    width: 120px !important;

    img{
    
      object-fit: contain;
      max-width: 75px;
      max-height: 40px;
      
    }
  }

  @media screen  and (max-width: 600px) {
    width: 110px !important;

    img{
      
      object-fit: contain;
      max-width: 75px;
      max-height: 40px;
      
    }
    font-size: 12px;
  }
  @media screen  and (max-width: 490px) {
    width: 100px !important;

    img{
     
      object-fit: contain;
      max-width: 75px;
      max-height: 40px;
    }
  }
  @media screen  and (max-width: 430px) {
    width: 95px !important;

    img{
    
      object-fit: contain;
      max-width: 70px;
      height: 30px;
    }
  }
  @media screen  and (max-width: 400px) {
    width: 85px !important;

    img{
      object-fit: contain;
      max-width: 65px;
      height: 30px;
      
    }
  }
`

export const SliderCatItem = styled(Link)`
  width: 100%;
  min-height: 323px;
  text-decoration: none;
  position: relative;
  padding-right: 15px;
  
  img {
    width: 100%;
    height: 100%;
    /* position: absolute; */
    z-index: -1;
  }

  h4 {
    width: 100%;
    font-size: 16px;
    font-family: ${props => props.theme.font.family.bold};
    color: white;
    position: absolute;
    bottom: 10px;
    text-align: center;
  }
  @media screen and (min-width: 1100px) {
    min-height: 170px;
    padding-right: 15px;
    &:not(:last-child):before {
      content: "";
      display: block;
      height: 70%;
      position: absolute;
      background: rgba(0,0,0,.1);
      top: 50%;
      width: 1px;
      right: 0;
      transform: translateY(-50%);
    }
  }

`

export const SliderCategory = styled.div`
  width: 100%;
  display: flex;
  padding: 15px 0px;

  .slick-dots {
    bottom: -30px;
  }
  .slick-slider {
    width: 100%;
    .category {
      background-image: unset;
    }
  }

  @media screen and (min-width: 1100px) {
    display: none;

    &.desktop-category {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: 15px;
      padding-bottom: 0px;
    }
  }
 
`
